import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fb91234"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "post d-flex flex-column-fluid",
  id: "kt_post"
}
const _hoisted_2 = {
  id: "kt_content_container",
  class: "container-xxl"
}
const _hoisted_3 = {
  key: 0,
  class: "d-flex flex-wrap flex-stack my-5"
}
const _hoisted_4 = { class: "fs-2 fw-bold my-2" }
const _hoisted_5 = { class: "d-flex flex-wrap my-1 gap-2" }
const _hoisted_6 = { class: "position-relative" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-magnifier fs-3 position-absolute ms-3 mt-3 text-gray-500" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" })
], -1))
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg me-2" }, null, -1))
const _hoisted_10 = {
  key: 1,
  class: "mt-10"
}
const _hoisted_11 = {
  key: 2,
  class: "row g-6 g-xl-9"
}
const _hoisted_12 = {
  key: 3,
  class: "text-center py-10"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-search-list fs-5tx text-gray-500 mb-5" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path3" })
], -1))
const _hoisted_14 = { class: "text-gray-800 fw-bold mb-2" }
const _hoisted_15 = { class: "text-gray-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_certification_card = _resolveComponent("certification-card")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.certifications)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.certification.list.title`) || 'Certificações Disponíveis'), 1),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                    onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filterCertifications && _ctx.filterCertifications(...args))),
                    class: "form-control form-control-sm ps-10",
                    placeholder: _ctx.$t(`${_ctx.currentLanguage}.certification.list.search_placeholder`) || 'Buscar certificação...',
                    style: {"min-width":"250px"}
                  }, null, 40, _hoisted_8), [
                    [_vModelText, _ctx.searchQuery]
                  ])
                ]),
                (_ctx.searchQuery)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args))),
                      class: "btn btn-sm btn-light-danger d-flex align-items-center"
                    }, [
                      _hoisted_9,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.clear`) || 'Limpar'), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.certification.list.loading`) || 'Carregando certificações') + "... ", 1)),
        (_ctx.certifications && _ctx.filteredCertifications.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCertifications, (certification) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4",
                  key: certification.id
                }, [
                  _createVNode(_component_certification_card, {
                    certification: certification,
                    "current-language": _ctx.currentLanguage
                  }, null, 8, ["certification", "current-language"])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.certifications && _ctx.filteredCertifications.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("h3", _hoisted_14, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.certification.list.no_results`) || 'Nenhuma certificação encontrada'), 1),
              _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.certification.list.no_results_desc`) || 'Tente ajustar sua busca'), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_router_view)
  ], 64))
}